import { render, staticRenderFns } from "./SamplesList.vue?vue&type=template&id=460f4c20&"
import script from "./SamplesList.vue?vue&type=script&lang=js&"
export * from "./SamplesList.vue?vue&type=script&lang=js&"
import style0 from "./SamplesList.vue?vue&type=style&index=0&id=460f4c20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports